export default "__VITE_ASSET__B_3N_eM3__"